import styled, { css } from 'styled-components';

import { Page, PageContent, token } from '@zillow/constellation';

import { SETTINGS } from '@zg-rentals/zrm-utils-js';

const getBorderBottomColor = ({ borderBottomColor }: { borderBottomColor: string }) => {
  if (borderBottomColor) {
    return css`
      border-bottom: 1px solid ${token(`colors.${borderBottomColor}`)};
    `;
  }

  return null;
};

export const StyledPage = styled(Page)<{
  backgroundColor?: string;
  borderBottomColor?: string;
  isFixedPosition?: boolean;
  offsetTop?: string | undefined;
  offsetForLeftNav?: boolean;
}>`
  position: ${({ isFixedPosition }) => (isFixedPosition ? 'fixed' : 'sticky')};
  top: ${({ offsetTop }) => (offsetTop !== undefined ? `${offsetTop}px` : 0)};
  left: 0;
  right: 0;
  width: 100%;
  background-color: ${({ backgroundColor }) => token(`colors.${backgroundColor}`)};
  ${({ borderBottomColor }) => borderBottomColor && getBorderBottomColor};
  z-index: ${({ isFixedPosition }) => (isFixedPosition ? token('zIndices.modal') : '0')};

  @media (min-width: ${`${SETTINGS.BREAKPOINTS_XL}px`}) {
    left: ${({ offsetForLeftNav }) => (offsetForLeftNav ? `${SETTINGS.LEFT_NAV_WIDTH}px` : 0)};
    max-width: ${({ offsetForLeftNav }) => (offsetForLeftNav ? '1232px' : null)};
    margin: 0 auto;
  }
`;

export const StyledPageContent = styled(PageContent)`
  margin: 0 auto;
  padding: 0;
`;

export const StyledHiddenDiv = styled.div`
  height: 0;
  visibility: hidden;
`;

export const StyledFixedHeightContainer = styled(Page)<{
  isFixedPosition?: boolean;
  offsetForLeftNav?: boolean;
  backgroundColor?: string;
  borderBottomColor?: string;
  offsetTop?: string | undefined;
  styles?: Record<string, unknown>;
}>`
  ${({ styles }) => styles}
  background-color: ${({ backgroundColor }) => token(`colors.${backgroundColor}`)};
  width: 100%;
  ${({ borderBottomColor }) => borderBottomColor && getBorderBottomColor};
  top: ${({ offsetTop }) => (offsetTop !== undefined ? `${offsetTop}px` : 0)};
  position: ${({ isFixedPosition }) => (isFixedPosition ? 'fixed' : 'sticky')};
  z-index: ${({ isFixedPosition }) => (isFixedPosition ? token('zIndices.modal') : '0')};

  @media (min-width: ${`${SETTINGS.BREAKPOINTS_XL}px`}) {
    left: ${({ offsetForLeftNav }) => (offsetForLeftNav ? `${SETTINGS.LEFT_NAV_WIDTH}px` : 0)};
  }
`;
